import { Component, Inject, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth.service';

interface Oranisation {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-select-company-org',
  standalone: false,
  template: `
  <mat-card>
      <mat-card-header>
          <h3>Select preferred dashboard</h3>
      </mat-card-header>
      <mat-card-content>
          <form>
            <mat-form-field>
              <mat-select [(ngModel)]="selectedValue" name="organisation">
                <mat-option *ngFor="let org of organisations" [value]="org.value" [disabled]="org.value === '0'">{{org.viewValue}}</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
      </mat-card-content>
      <mat-dialog-actions>
        <button mat-button (click)="showOrg()" [disabled]="selectedValue === '0'">Select</button>
      </mat-dialog-actions>
  </mat-card>`,
  styleUrls: ['./select-company-org.component.scss'],
})

export class SelectCompanyOrgComponent implements OnInit {
  selectedValue: string = '0';
  organisations: Oranisation[] = [];

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SelectCompanyOrgComponent>,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    
  }

  ngOnInit() {
    if (this.data && Array.isArray(this.data)) {
      this.organisations = [
        { value: '0', viewValue: 'Select' },
        ...this.data.map((org: any) => ({
        value: org.id.toString(),
        viewValue: org.name
        }))
      ];
      this.selectedValue = this.organisations[0].value;
    } else{
      this.organisations = [{ value: '0', viewValue: 'Select' }];
    }
  }
  // Logic to close the modal
  showOrg(): void {
      localStorage.setItem('companyId', this.selectedValue);
      this.dialogRef.close(this.selectedValue);
      this.authService.selectedOrg.next(this.selectedValue)
  }

}
